import { useGlobalEntityListSuspense } from "gen/endpoints/global-entity/global-entity";
import { GlobalEntityData } from "gen/model/globalEntityData";
import React, { useMemo } from "react";
import {
  FormSelect,
  FormSelectProps,
} from "shared/components/input/select/Select";
import { SelectOption } from "shared/components/input/select/SelectOption";
import { FormInputValue } from "shared/types/FormInputValue";

export interface FormEntitySelectProps<
  T extends FormInputValue = string,
  IsMulti extends boolean = boolean,
> extends FormSelectProps<T, IsMulti> {
  filter?: (entity: GlobalEntityData) => boolean;
}

export const FormEntitySelect: React.FC<FormEntitySelectProps> = ({
  filter,
  ...props
}) => {
  const entities = useGlobalEntityListSuspense();

  const options = useMemo(
    () =>
      entities.data
        .filter((entity) => !filter || filter(entity))
        .map((entity) => (
          <SelectOption key={entity.id} value={entity.id!}>
            {entity.legal_name}
          </SelectOption>
        )),
    [entities.data, filter],
  );

  return <FormSelect {...props}>{options}</FormSelect>;
};
